
import { observable, action, makeObservable } from 'mobx';
import UserStore from './user-store';
import OptionStore from './option-store';
import EventStore from './event-store';
import NewsStore from './news-store';
import PaymentStore from './payment-store';
import PermissionStore from './permission-store';
import PublicStore from './public-store';
import NotificationStore from './notification-store';
interface WebNotification {
  message: string;
  options?: {
    variant: "success" | "error" | "info" | "warning";
  };
}

export default class RootStore {
  testVal = "TEST_VALUE";

  destination = "Select";

  notification: WebNotification = {
    message: "",
    options: {
      variant: "info",
    },
  };

  userStore;

  optionStore;

  eventStore;

  newsStore;

  paymentStore;

  permissionStore;

  publicStore;

  notificationStore;

  constructor() {
    makeObservable(this, {
      testVal: observable,
      destination: observable,
      notification: observable,
      notify: action,
    });
    this.userStore = new UserStore(this);
    this.optionStore = new OptionStore(this);
    this.eventStore = new EventStore(this);
    this.newsStore = new NewsStore(this);
    this.paymentStore = new PaymentStore(this);
    this.permissionStore = new PermissionStore(this);
    this.publicStore = new PublicStore(this);
    this.notificationStore = new NotificationStore(this);
  } 

  notify(msg: string, level?: "success" | "error" | "info" | "warning") {
    if (level) {
      this.notification = {
        message: msg,
        options: {
          variant: level,
        },
      };
    } else {
      this.notification = {
        message: msg,
      };
    }
  }
}
